// extracted by mini-css-extract-plugin
module.exports = {"s1m6raig":"s1m6raig"};